"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulingTypes = void 0;
exports.haulingTypes = {
    SET_ERROR: 'HAULING TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'HAULING TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'HAULING TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'HAULING TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'HAULING TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'HAULING TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'HAULING TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'HAULING TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'HAULING TYPES SET SUCCESS MODAL',
    SET_EXPORT_DOCUMENTS: 'HAULING TYPES SET EXPORT DOCUMENTS',
    CLEAR_EXPORT_DOCUMENTS: 'HAULING TYPES CLEAR EXPORT DOCUMENTS',
};
